import {CnameRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

let service = {};

service.getDomainUrlByWidgetId = async (widgetId) => {
  let hostname;
  if (widgetId) {
    const response = await service.getHostnamesByWidgetIds([widgetId], null);
    if (response.success) {
      const widgetIdToCnameHostMap = response.data?.widgetIdToCnameHostMap;
      if (widgetIdToCnameHostMap && widgetIdToCnameHostMap[widgetId]) {
        hostname = widgetIdToCnameHostMap[widgetId];
      }
    }
  }
  const domainUrl = utilsService.getClickNTalkPageDomainUrl(hostname);
  return domainUrl;
};

service.getHostnamesByWidgetIds = async (widgetIds, token) => {
  const requestObj = {
    endpoint: 'hostname/widgetIds',
    widgetIds,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.get(requestObj, requestObj);
  return response.data;
};

service.createCnameInstance = async (requestObj, token) => {
  let requestObject = {
    ...requestObj,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.save(
    {
      endpoint: 'accountId',
    },
    requestObject,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.getCnameInstancesByAccountId = async (accountId, token) => {
  let requestObject = {
    accountId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.get(
    {
      endpoint: 'accountId',
      endpointParam: accountId,
    },
    requestObject,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.verifyCnameInstanceByCnameInstanceId = async (
  cnameInstanceId,
  token,
) => {
  let requestObject = {
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'verify/cnameInstanceId',
      endpointParam: cnameInstanceId,
    },
    requestObject,
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

service.assignCnameInstanceToWidgets = async (
  widgetIds,
  cnameInstanceId,
  token,
) => {
  let requestObject = {
    widgetIds,
    cnameInstanceId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'assign/widgetIds',
    },
    requestObject,
  );
  return response.data;
};

service.unassignWidgetsFromAllCnames = async (widgetIds, token) => {
  let requestObject = {
    widgetIds,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await CnameRestService.update(
    {
      endpoint: 'unassign/widgetIds',
    },
    requestObject,
  );
  return response.data;
};

service.deleteCnameInstanceByInstanceId = async (cnameInstanceId, token) => {
  const _token = token ? token : storageService.getItem('token');
  const response = await CnameRestService.delete(
    {
      endpoint: cnameInstanceId,
      token: _token,
    },
    {
      endpoint: cnameInstanceId,
      token: _token,
    },
  );
  if (response.data?.success) {
    return response.data;
  } else {
    const errorMsg = utilsService.getApiErrorMessage(response.data.message);
    response.data.message = errorMsg;
    return response.data;
  }
};

const cnameInstanceService = {...service};

export default cnameInstanceService;
